import { createStringEnum, EnumValues } from '@lib/shared-interface-utility-types';

export const UserApplication = createStringEnum(['INTERNAL', 'SCHOOL', 'STUDENT']);
export type UserApplication = EnumValues<typeof UserApplication>;

export const USER_APPLICATIONS = Object.values(UserApplication);
